<section class="page">
  <header class="page__header">
    <div class="header-left">
      <h1>Risiko &amp; Money Management</h1>
      <p>Steuere Verlustschwelle, Basis-Risiko und stufenbasierte Erhöhung.</p>
    </div>
    <div class="header-actions">
      <label class="pill pill--select" *ngIf="hasProfiles">
        Planungsjahr:
        <select [ngModel]="selectedPlanYear" (ngModelChange)="onPlanYearChange($event)" [ngModelOptions]="{standalone: true}">
          <option *ngFor="let year of yearOptions" [value]="year">{{ year }}</option>
        </select>
      </label>
      <button class="secondary" type="button" (click)="openNewProfile()">Neues Profil</button>
      <div class="new-profile" *ngIf="newProfileOpen">
        <label>
          Neues Jahr
          <input type="number" min="2025" step="1" [(ngModel)]="newProfileYear" [ngModelOptions]="{standalone: true}" />
        </label>
        <div class="new-profile__actions">
          <button class="primary" type="button" (click)="saveNewProfile()">Speichern</button>
          <button class="secondary" type="button" (click)="cancelNewProfile()">Abbrechen</button>
        </div>
        <div class="error" *ngIf="newProfileError">{{ newProfileError }}</div>
      </div>
      <button class="primary" (click)="saveProfile()" [disabled]="!hasProfiles">Profil speichern</button>
      <button class="secondary" type="button" (click)="deleteProfile()" [disabled]="!hasProfiles">Profil löschen</button>
    </div>
  </header>

  <div class="empty-state card card--subtle" *ngIf="!hasProfiles">
    Noch keine Profile vorhanden. Bitte zuerst ein neues Profil anlegen.
  </div>

  <div class="plan-sheet card card--subtle" *ngIf="hasProfiles && profileForm.value.planYear">
    <div class="plan-sheet__title">Planung für {{ profileForm.value.planYear }}</div>
    <div class="plan-sheet__grid">
      <div>Chance/Risiko: <strong>{{ profileForm.value.riskRewardRatio }}</strong></div>
      <div>Gewinnwahrscheinlichkeit: <strong>{{ profileForm.value.winProbabilityPct }}%</strong></div>
      <div>Zielmarke: <strong>{{ profileForm.value.targetGoalEUR }} €</strong></div>
    </div>
  </div>

  <form *ngIf="hasProfiles" [formGroup]="profileForm" class="grid risk-form">
    <label>
      Maximale Verlustschwelle (€)
      <input type="number" formControlName="maxLossThresholdEUR" min="0" step="50" (blur)="saveProfile()" (change)="saveProfile()" />
    </label>
    <label>
      Basis-Risiko pro Trade (€)
      <input type="number" formControlName="baseRiskPerTradeEUR" min="0" step="1" (blur)="saveProfile()" (change)="saveProfile()" />
    </label>
    <label>
      Chance/Risiko (z. B. 2 für 1:2)
      <input type="number" formControlName="riskRewardRatio" min="0.1" step="0.1" (blur)="saveProfile()" (change)="saveProfile()" />
    </label>
    <label>
      Gewinnwahrscheinlichkeit (%)
      <input type="number" formControlName="winProbabilityPct" min="0" max="100" step="1" (blur)="saveProfile()" (change)="saveProfile()" />
    </label>
    <label>
      Zielmarke (€)
      <input type="number" formControlName="targetGoalEUR" min="0" step="100" (blur)="saveProfile()" (change)="saveProfile()" />
    </label>
    <div class="summary">
      <div>Gesamt-Risikobudget: <strong class="numeric">{{ summary().totalBudget | number:'1.0-2' }} €</strong></div>
      <div>Risiko pro Trade: <strong class="numeric">{{ summary().riskPerTrade | number:'1.0-2' }} €</strong></div>
      <div *ngIf="summary().appliedLabel" class="hint">Stufe: {{ summary().appliedLabel }}</div>
    </div>
  </form>

  <section *ngIf="hasProfiles" class="card card--subtle">
    <header class="card__header">
      <div>
        <h2>Stufen (profitMinEUR → Risiko/Trade)</h2>
        <p>Aufsteigend, erweiterbar ohne Codeänderung.</p>
      </div>
      <div class="card__actions">
        <button type="button" class="secondary" (click)="addStep()">Stufe hinzufügen</button>
        <button type="button" class="secondary" (click)="autoExtendSteps()">Sequenz erweitern</button>
      </div>
    </header>

    <div class="table">
      <div class="table__head">
        <div>Profit ab (€)</div>
        <div>Risiko pro Trade (€)</div>
        <div>Trades bis nächste Stufe</div>
        <div></div>
      </div>
      <div class="table__body" *ngFor="let step of stepControls; let i = index" [formGroup]="step">
        <div>
          <input type="number" min="0" step="50" formControlName="profitMinEUR" (blur)="onStepBlur(i)" />
        </div>
        <div>
          <input type="number" min="0" step="1" formControlName="riskPerTradeEUR" (blur)="onStepBlur(i)" />
        </div>
        <div class="numeric">{{ tradesToNextStep(i) ?? '–' }}</div>
        <div class="actions">
          <button type="button" class="secondary danger" (click)="removeStep(i)" [disabled]="i !== stepControls.length - 1 || stepControls.length <= 1">Löschen</button>
        </div>
      </div>
    </div>

    <div class="error" *ngIf="stepsError">{{ stepsError }}</div>
  </section>
</section>
